module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/hero@2x.10700a4.png";